import request from '../../utils/request';
import options from './options';

const url = options.apiUrl;
const urlPath = path => `${url}${path}`;

export const getRegistrants = (filter = '') => request.get({
    url: urlPath(filter)
});

export const getRegistrant = id => request.get({
    url: urlPath(`${id}/`)
});